var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMenu = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,14.5H4.7c-2.1,0-3.7-1.7-3.7-3.7C1,8.7,2.7,7,4.7,7h45.6c2.1,0,3.7,1.7,3.7,3.7 C54,12.8,52.3,14.5,50.3,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,31.2H4.7c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7h45.6c2.1,0,3.7,1.7,3.7,3.7S52.3,31.2,50.3,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,48H4.7C2.7,48,1,46.3,1,44.3s1.7-3.7,3.7-3.7h45.6c2.1,0,3.7,1.7,3.7,3.7S52.3,48,50.3,48z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.42ef440d.svg";
export { ForwardRef as ReactComponent };